import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';

interface CartItemPriceDisplayProps {
  price: string; // The main price text, properly formatted.
  originalPrice?: string; // Optional original price text to display as a discount.
  textColor?: string; // Color to apply to the price (defaulting to Colors.navyBlue).
  testId?: string; // Optional test ID for the price container.
  showOriginalPrice?: boolean; // Option to force show the original price even if empty.
}

const CartItemPriceDisplay: React.FC<CartItemPriceDisplayProps> = ({
  price,
  originalPrice,
  textColor = Colors.navyBlue,
  testId = '',
  showOriginalPrice = false
}) => {
  return (
    <PriceContainer $variant={TextVariant.BodyBoldMD} $textColor={textColor}>
      {(showOriginalPrice || (originalPrice && originalPrice !== '')) && (
        <span className="original-price" data-testid="original-price">
          {originalPrice}
        </span>
      )}
      <span className="price" data-testid={testId ?? ''}>
        {price}
      </span>
    </PriceContainer>
  );
};

export default CartItemPriceDisplay;

const PriceContainer = styled(Typography)<{ $textColor: string }>`
  display: flex;
  flex-direction: column-reverse;
  min-width: 60px;
  margin-left: 5px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 17px;
    min-width: 54px;
  }

  & span.original-price {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    text-decoration-line: line-through;
    opacity: 0.5;
  }

  & span.original-price:not(:empty) + span.price {
    color: ${Colors.gold};
  }

  span {
    color: ${({ $textColor }) => $textColor};
  }
`;
